import React from 'react'
import { IFormattedDataByGrower } from './types/growerData'
import DropdownWrapper from './ui/DropdownWrapper';
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon';
import SectionProductWrapper from './ui/SectionProductWrapper';
import NestedItem from './NestedItem';

interface ITransportationGrowerItemProp {
  grower: IFormattedDataByGrower
  handlePrintByGrower: (GrowerID: number) => void
}

const TransportationGrowerItem = (props: ITransportationGrowerItemProp) => {
  const { grower, handlePrintByGrower } = props;
  return (
    <DropdownWrapper
      title={grower.Grower_Name}
      icon={<UserIcon />}
      handlePrint={() => handlePrintByGrower(grower.GrowerID)}
    >
      {grower.OrderDetails.map((order) => (
        <SectionProductWrapper
          key={`${order.product.ProductID}-${order.product.VarietyID}-${order.product.SizeID}-${order.product.CustomerID}`}
          list={order.byCustomer}
          product={order.product} 
        >
          {order.byCustomer.map((customer, index) => (
            <NestedItem
              key={customer.CustomerID}
              title={customer.Customer_Name}
              index={index}
              item={customer}
              palletQty={customer.Order_Pallets}
            />
          ))}
        </SectionProductWrapper>
      ))}
    </DropdownWrapper>
  )
}

export default TransportationGrowerItem